<template>
    <div>
        <h1 style="font-size: 24px; color: black;">矩阵吸量效果日报</h1>
        <div class="block" >
            <span >游戏名称：</span>
            <el-select v-model="queryData.gameIds" multiple filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in gameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
:clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span >渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId"  clearable placeholder="请选择" >
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel"></el-option>
            </el-select>
            <span >矩阵位置：</span>
            <el-select v-model="queryData.plateId" clearable  filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in MatrixStyles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

            <el-button  type="primary" class="margin-left-10"  @click="query" >查询</el-button>
            <el-button  type="primary" @click="exportExcel()" >导出报表</el-button>
        </div>
        <h1>
<!--            <el-table border :data="jumpGameReport.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"-->
            <el-table border :data="jumpGameReport"
                      :header-cell-style="{background:'#282828'}"
                      @sort-change='sortChange'
                      ref="filterTable"
                      max-height="820">
                <el-table-column  type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="dt" label="日期" sortable='custom'></el-table-column>
                <el-table-column prop="gameName" label="游戏名称"></el-table-column>
                <el-table-column prop="plateName" label="矩阵位置"></el-table-column>
                <el-table-column prop="targetName" label="推广游戏"></el-table-column>
                <el-table-column prop="clUser" label="点击用户数" sortable='custom'></el-table-column>
                <el-table-column prop="clOpen" label="点击次数" sortable='custom'></el-table-column>
                <el-table-column  label="点击率" sortable='custom' prop="clRate">
                    <template slot-scope="scope">
                      {{scope.row.clRate==null?'0.00%':(scope.row.clRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column  label="人均点击次数" sortable='custom' prop="clPerUser">

                    <template slot-scope="scope">
                      {{scope.row.clPerUser==null?'0.00':scope.row.clPerUser.toFixed(2)}}
                    </template>
                </el-table-column>
            </el-table>

            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {
  channelList,
  downloadData,
  gameSimpleList,
  searchJumpGameReport,

} from "@/http/api";
import utils from '@/utils'
    // import XLSX from "xlsx";
    // import FileSaver from "file-saver";

    export default {
        name: "JumpGameReport",
        data(){
            return{
                gameList:[],
                channelList:[],
                subChannelList:[],
                jumpGameReport:[],
                plateRules:[],
                watchTag:'',
                queryData:{
                    gameIds:[],
                    channelId:'',
                    subChannelId:'',
                    plateId:'',
                    timeDate:['',''],
                },
                queryTrueData:{
                    gameIds:[],
                    channelId:'',
                    subChannelId:'',
                    plateId:'',
                    startTime:'',
                    endTime:'',
                  order:null,
                  prop:null
                },
                queryInfo:{
                    pagesize:20,
                    pagenum:1,
                    total:0,
                },
                MatrixStyles: [
                    {id:200000010000000,name:'侧边栏'},
                    {id:300000011000000,name:'退出矩阵'},
                    {id:400000012000000,name:'底部banner'},
                    {id:500000013000000,name:'首推挂件'},
                    {id:600000014000000,name:'插屏弹窗'},
                    {id:120000001000000,name:'211矩阵1'},
                    {id:120000002000000,name:'211矩阵2'},
                    {id:120000003000000,name:'211矩阵3'},
                    {id:120000004000000,name:'211矩阵4'},
                    {id:120000005000000,name:'211矩阵5'},
                ],
            }
        },
        methods:{
            selectGoodsByChannelId(val){
                this.watchTag = val;
                if(val !== null && val !== '' && val !== undefined && val !=='0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
                }
                if (val==='0'){
                    this.subChannelList=[];
                }
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.queryJumpGameReportList();

            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
              this.queryJumpGameReportList();
            },
            query(){
                this.queryInfo.pagenum=1;
                this.queryJumpGameReportList();
            },
            queryJumpGameReportList(){
                if (this.queryData.timeDate===null){
                    this.queryData.timeDate=['',''];
                }
                this.queryTrueData.gameIds=this.queryData.gameIds;
                this.queryTrueData.channelId=this.queryData.channelId;
                this.queryTrueData.subChannelId=this.queryData.subChannelId;
                this.queryTrueData.plateId=this.queryData.plateId;
                this.queryTrueData.startTime= this.queryData.timeDate[0];
                this.queryTrueData.endTime=this.queryData.timeDate[1];
              this.queryTrueData.size=this.queryInfo.pagesize;
              this.queryTrueData.page=this.queryInfo.pagenum;
                searchJumpGameReport(this.queryTrueData).then(resp=>{
                  this.jumpGameReport=resp.data.info.list;
                    // this.jumpGameReport=resp.data.info.sort((a,b) => (new Date(b.dt) - new Date(a.dt)));
                    let _this =this;
                    //this.plateGameReport=this.plateGameReport.filter(pgr=>pgr.name!==undefined);
                    this.jumpGameReport.forEach(function (jumpGameReport) {
                        _this.MatrixStyles.forEach(function (matrix) {
                            if (jumpGameReport.pid===matrix.id ){
                                _this.$set(jumpGameReport,'plateName',matrix.name);
                            }
                        })
                    });
                  this.queryInfo.total=resp.data.info.totalElements;
                });
            },
            // exportExcel () {
            //     this.queryInfo.pagesize = this.queryInfo.total;
            //     this.queryInfo.pagenum = 1;
            //     this.$nextTick(function () {
            //         let wb = XLSX.utils.table_to_book(this.$refs.filterTable.$el);
            //         let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            //         try {
            //             FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '矩阵吸量效果日报'+new Date().toLocaleString()+'.xlsx');
            //         } catch (e) {
            //             if (typeof console !== 'undefined') console.log(e, wbout)
            //         }
            //         this.queryInfo.pagesize = 10;
            //         return wbout;
            //     })
            // },
          exportExcel () {
            let fileName = new Date().toLocaleString()+'矩阵吸量效果日报.xlsx';
            downloadData(
                '/matrix/searchJumpGameReportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
          },
          sortChange(order){
            this.queryTrueData.order=order.order;
            this.queryTrueData.prop=order.prop;
            this.queryJumpGameReportList();
          }
        },
        watch:{
            watchTag(){
                this.queryData.subChannelId='';
            }
        },
        created(){
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp=>{
                this.channelList=resp.data.info;
            });
            gameSimpleList().then(resp=>{
                this.gameList=resp.data.info;
            });
            // listJumpGameReport().then(resp=>{
            //     this.jumpGameReport=resp.data.info.sort((a,b) => (new Date(b.dt) - new Date(a.dt)));
            //     let _this =this;
            //     this.jumpGameReport.forEach(function (jumpGameReport) {
            //         _this.MatrixStyles.forEach(function (matrix) {
            //             if (jumpGameReport.pid===matrix.id ){
            //                 _this.$set(jumpGameReport,'plateName',matrix.name);
            //             }
            //         })
            //     });
            //     this.queryInfo.total=this.jumpGameReport.length;
            // });
          this.queryJumpGameReportList();
        }

    }
</script>

<style scoped>

</style>
